/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductCollectionValuesQueryResponse,
  FindProductCollectionValuesQueryParams,
} from "../types/FindProductCollectionValues.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductCollectionValuesQueryKey = (
  params?: FindProductCollectionValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-collection-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductCollectionValuesQueryKey = ReturnType<
  typeof findProductCollectionValuesQueryKey
>

/**
 * @summary Find product collection values
 * {@link /v1/product/find-product-collection-values}
 */
export async function findProductCollectionValues(
  params?: FindProductCollectionValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductCollectionValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-collection-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductCollectionValuesQueryOptions(
  params?: FindProductCollectionValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductCollectionValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductCollectionValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductCollectionValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductCollectionValues(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find product collection values
 * {@link /v1/product/find-product-collection-values}
 */
export function useFindProductCollectionValues<
  TData = ResponseConfig<FindProductCollectionValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductCollectionValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductCollectionValuesQueryKey,
>(
  params?: FindProductCollectionValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductCollectionValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductCollectionValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductCollectionValuesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
